import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHero, PrimaryButton, Reveal, SectionTag } from "@/components/ui-bits";
import { SOLUTIONS } from "@/content/site";

const Solutions = () => (
  <>
    <PageHero
      eyebrow="Solutions — What TARK can build"
      lines={["Platforms and Products,", "Built Around Your Business."]}
      sub="Services describe what TARK does. Solutions describe what TARK can build for you — from SaaS platforms and AI agents to enterprise integration platforms."
    />
    <section className="mx-auto max-w-7xl px-6 pb-28 lg:px-10" data-testid="solutions-grid">
      <div className="grid gap-px overflow-hidden rounded-2xl border border-tark-line bg-tark-line sm:grid-cols-2 lg:grid-cols-3">
        {SOLUTIONS.map((s, i) => (
          <Reveal key={s.name} delay={(i % 3) * 0.05} className="bg-tark-bg">
            <div className="group flex h-full flex-col p-8 transition-colors duration-300 hover:bg-tark-card"
                 data-testid={`solution-card-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] text-tark-dim">{String(i + 1).padStart(2, "0")}</span>
                <ArrowUpRight className="h-4 w-4 text-tark-dim opacity-0 transition-all duration-300 group-hover:text-tark-cyan group-hover:opacity-100" />
              </div>
              <h3 className="mt-8 font-display text-lg font-bold tracking-tight group-hover:text-tark-cyan">{s.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-tark-mut">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20 rounded-2xl border border-tark-line bg-tark-surface/60 p-10 text-center sm:p-14">
        <SectionTag>Have something specific in mind?</SectionTag>
        <h2 className="mt-4 font-display text-2xl font-bold sm:text-3xl">Build With TARK</h2>
        <p className="mx-auto mt-4 max-w-xl text-sm text-tark-mut">
          If it runs on software, we can engineer it. Tell us what you need built.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <PrimaryButton to="/start-a-project" testId="solutions-page-cta">Discuss Your Project</PrimaryButton>
        </div>
        <p className="mt-6 text-xs text-tark-dim">
          Looking for a role instead? <Link to="/careers" className="text-tark-cyan hover:underline" data-testid="solutions-careers-link">Explore careers at TARK</Link>
        </p>
      </Reveal>
    </section>
  </>
);

export default Solutions;
